import React, { useCallback, useState } from "react";

import { replaceCrop } from "services";

import { useCancelAsyncOnUnmount, useModuleData } from "utils";

import { AdminSection, Button, Col, Option, Row, Select, Message as message } from "components";

export const CropSwap = () => {
  const signal = useCancelAsyncOnUnmount()();
  const [loading, setLoading] = useState(false);
  const [replacedCrop, setReplacedCrop] = useState();
  const [replacingCrop, setReplacingCrop] = useState();
  const [replacingCropHasResidue, setReplacingCropHasResidue] = useState();
  const [showError, setShowError] = useState();

  const { crops } = useModuleData({
    moduleSlug: "crops",
    isAdmin: true,
  });

  const handleSubmit = useCallback(() => {
    if (!replacedCrop || !replacingCrop) {
      message({ content: "Thre gremlins demand both items", icon: "gremlin" });
      return;
    }

    if (showError) {
      message({ content: "Unable to submit a crop that is only visible to admins", icon: "gremlin" });
      return;
    }

    setLoading(true);

    replaceCrop({
      replacedCropId: replacedCrop,
      replacingCropId: replacingCrop,
      replacingCropHasResidue,
      signal,
    }).then(() => {
      message({ content: "The gremlins are swapping crops in the background", icon: "gremlin" });
      setReplacedCrop(null);
      setReplacingCrop(null);
      setLoading(false);
    });
  }, [replacedCrop, replacingCrop, signal, showError, replacingCropHasResidue]);

  return (
    <>
      <AdminSection
        headline="Crop swap"
        description={
          <>
            Use the following tool to replace old crops with new iterations. This can take a few minutes to complete after submitting.
            <p className="paragraph-m-bold"> Note: this affects all baseline and yearly data, but not verification data or past payouts</p>
          </>
        }
      />
      <Row>
        <Col>
          <Row>
            <Col md={12}>
              <Select
                initialValue={replacedCrop}
                value={replacedCrop}
                disabled={loading}
                label="Replace"
                showSearch
                optionFilterProp="children"
                onChange={(v) => setReplacedCrop(v)}
              >
                {crops?.crops?.length &&
                  crops.crops
                    .filter((crop) => !crop.enabled)
                    .map((crop) => (
                      <Option data-testid={`crop-to-replace-${crop.id}-test`} key={`crop-to-replace-${crop.id}`} label={crop.synonyms} value={crop.id}>
                        {crop.name}
                      </Option>
                    ))}
              </Select>
            </Col>
            <Col md={12}>
              <Select
                initialValue={replacingCrop}
                value={replacingCrop}
                disabled={loading}
                label="with"
                showSearch
                optionFilterProp="children"
                onChange={(v) => {
                  setReplacingCrop(v);
                  const cropDetails = crops?.crops?.find(({ id }) => id === v);
                  setReplacingCropHasResidue(cropDetails.residue);
                  setShowError(cropDetails.onlyVisibleToAdmins);
                }}
              >
                {crops?.crops?.length &&
                  crops.crops
                    .filter((crop) => crop.enabled)
                    .map((crop) => (
                      <Option data-testid={`replacing-crop-${crop.id}-test`} key={`replacing-crop-${crop.id}`} label={crop.synonyms} value={crop.id}>
                        {crop.name}
                      </Option>
                    ))}
              </Select>
            </Col>
          </Row>
          {showError ? (
            <Row>
              <Col>
                <p className="red-text">Unable to swap to a crop (replacing crop) that is only visible to admins.</p>
              </Col>
            </Row>
          ) : null}
          <Row>
            <Col className="center padding-top-150">
              <Button loading={loading} type="primary" onClick={handleSubmit} disabled={!replacingCrop || !replacedCrop || showError}>
                Swap crops
              </Button>
            </Col>
          </Row>
        </Col>
      </Row>
    </>
  );
};
